import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PreEnrolledAccountsService } from '../pre-enrolled-accounts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { IPreInrolatInfo } from '../pre-enrolled-accounts.interface';

@Component({
    selector: 'app-info-pre-inrolat',
    templateUrl: './info-pre-inrolat.component.html',
    styleUrls: ['./info-pre-inrolat.component.scss']
})
export class InfoPreInrolatComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    preInrolat!: IPreInrolatInfo;

    token!: string;
    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IPreInrolatInfo,
        private dialogRef: MatDialogRef<InfoPreInrolatComponent>,
        private preEnrolledAccountsService: PreEnrolledAccountsService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
        this.preInrolat = this.data;
    }
    ngOnInit(): void {
        this.getClientDetails(this.data.id);
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.preEnrolledAccountsService.setToken(token);
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    getClientDetails(preInrolatId: number) {
        this.preEnrolledAccountsService.getPreInrolatById(preInrolatId);
    }
}
